import { memo } from 'react';

import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

const Wrapper = styled('div')(() => ({
  boxSizing: 'border-box',
  width: '100vw',
  height: '100vh',
  paddingTop: '15vh'
}));

const LockIcon = styled(SharedAsset)(() => ({
  width: 100,
  margin: '8px auto 32px',
  display: 'block'
}));

const AuthLockIcon = memo(() => (
  <LockIcon
    src="/icon/misc/login-lock-256.svg"
    width={256}
    alt=""
  />
));

const AuthPageTemplate = ({ message = 'Redirecting...', children }) => (
  <Wrapper>
    <AuthLockIcon />
    <Title
      align="center"
      level={1}
      variant="md"
      gutterBottom
    >
      {message}
    </Title>
    {children}
  </Wrapper>
);

AuthPageTemplate.propTypes = {
  message: PropTypes.string,
  children: PropTypes.node
};

export default memo(AuthPageTemplate);
